<template>
    <div class="creditor-right">
        <div class="content" v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="10">
            <dl class="item-content" v-for="(item, index) in dataList" :key="index">
                <dt>{{item.borrower_name}}</dt>
                <dd>{{item.hold_amount && format(Number(item.hold_amount).toFixed(2))}}</dd>
            </dl>
            <div v-if="dataList.length === 0 && !loading" class="no-data">
                <img src="../../../assets/images/normal/null_icon_data.png" alt="暂无数据"/>
                <p>
                    暂无数据
                </p>
            </div>

        </div>
    </div>
</template>

<script>
    import infiniteScroll from "vue-infinite-scroll";
    import {formatNumber} from "@/utils/index";

    export default {
        name: "creditorRight",
        data() {
            return {
                dealNo: "",
                dataList: [],
                busy: false,
                loading: true
            };
        },
        directives: {infiniteScroll},
        created() {
            let params = this.$route.query;
            const {dealNo, token} = params;
            this.dealNo = dealNo;
            this.token = decodeURIComponent(token || "");

        },
        methods: {
            loadMore: (function () {
                let pageNo = 1;
                return function () {
                    this.$request({
                        url: "/h5/deal/jxlLoans.json",
                        data: this.$qs.stringify({
                            pageNo,
                            dealNo: this.dealNo,
                            token: this.token
                        })
                    })
                        .then(res => {
                            this.loading = false;
                            if (res.data.length === 0) {
                                return (this.busy = true);
                            }
                            pageNo++;
                            this.dataList.push(...res.data);
                        })
                        .catch(err => {
                            this.$toast(err);
                        });
                };
            })(),
            format(num) {
                return formatNumber(num);
            },
        }
    };
</script>

<style lang="less">
    .creditor-right {
        .no-data {
            height: 100vh;
            background: #FFFFFF;
            overflow: hidden;

            img {
                display: block;
                width: 120px;
                height: 120px;
                margin: 80px auto 20px;
            }

            p {
                font-size: 14px;
                color: #aaaaaa;
                text-align: center;
            }
        }

        .item-title {
            display: flex;
            font-size: 15px;
            padding: 0 16px;
            height: 44px;
            line-height: 44px;
            align-items: center;
            color: #C0A266;
            background: #F6F2EA;

            dt {
            }

            dd {
                flex: 1;
                text-align: right;
            }
        }

        .content {
            background: #FFFFFF;
            padding: 12px 0;
            border-radius: 24px;
        }

        .item-content {
            display: flex;
            font-size: 14px;
            margin: 0 16px;
            height: 44px;
            line-height: 44px;
            border-bottom: 1px solid #f6f6f6;
            color: #333333;

            dd {
                flex: 1;
                text-align: right;
            }

            &:last-child {
                border-bottom: 0
            }
        }
    }
</style>
